var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"page",staticClass:"login",attrs:{"id":"login"}},[_c('div',{ref:"bg",staticClass:"login_bg"},[_c('span',[_vm._v("404------找不到文件或目录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }